import React, {useState} from "react"

import {
  Navbar,
  NavbarBrand,
  NavbarBurger,
  NavbarItem,
  NavbarMenu,
  NavbarStart,
} from "bloomer"

import {Wrapper} from './HeaderStyle'

const Header = () => {
  const [state, setState] = useState({
    isActive: false
  })

   const onClickNav = () =>{
    setState({isActive: !state.isActive})
  }

  return (
  <Wrapper>
    <Navbar>
        <NavbarBrand className='brand'>
          <NavbarItem>
              <a href="https://www.apotekdirekte.no">Hjem</a>
          </NavbarItem>
          <NavbarBurger isActive={state.isActive} onClick={onClickNav}/>
        </NavbarBrand>
        <NavbarMenu isActive={state.isActive}>
          <NavbarStart>
            <NavbarItem>
              <a href="https://www.apotekdirekte.no">Hjem</a>
            </NavbarItem>
          </NavbarStart>
        </NavbarMenu>
    </Navbar>

  </Wrapper>

  )}


export default Header
